import axios from 'axios'
import { baseURL } from '../config/env'

export const API = (currentUser: any) =>
  axios.create({
    baseURL: baseURL,
    headers: {
      Authorization: currentUser.tokens.idToken.toString(),
    },
  })
